var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditkey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39895 9.13715V4.81597H12.6474C12.6474 7.19097 10.752 9.13715 8.39895 9.13715ZM8.39895 14.184V9.82986C10.752 9.82986 12.6474 11.776 12.6474 14.151L8.39895 14.184ZM7.71265 9.13715H3.46416C3.46416 6.72917 5.35964 4.81597 7.71265 4.81597V9.13715ZM7.71265 14.184C5.35964 14.184 3.46416 12.2378 3.46416 9.86285H7.71265V14.184ZM14.641 3.89236L8.07214 0L1.47063 3.89236C0.555572 4.42014 0 5.40972 0 6.46528V12.5017C0 13.5573 0.555572 14.5469 1.47063 15.1076L8.07214 19L14.6736 15.1076C15.5887 14.5799 16.1443 13.5903 16.1443 12.5017V6.46528C16.1116 5.40972 15.556 4.42014 14.641 3.89236Z",
    fill: "#0066FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditkey);
export default __webpack_public_path__ + "static/media/creditkey.ac7e3e30080282fd98455a5c22684685.svg";
export { ForwardRef as ReactComponent };